import { faBars, faChevronDown, faX } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ProgressBar from './ProgressBar';
import { ReactComponent as GymLogo } from '../assets/images/Privategym_schijndel_logo.svg';
import { goToMemberships } from '../utils/ScrollToSection';

const aboutPaths = ['/concept', '/about', '/rooms', '/faq'];

const HeaderBar = () => {
    const [isTop, setIsTop] = useState(true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isAboutOpen, setIsAboutOpen] = useState(false);
    const menuIcon = <FontAwesomeIcon icon={isMenuOpen ? faX : faBars}/>;
    const navigate = useNavigate();
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
        setIsAboutOpen(false);
    };

    const handleScroll = () => {
        setIsTop(window.scrollY <= 100);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav id="main-header"
             className={`h-auto xl:h-20 w-full transition-all fixed top-0 z-50 ${isTop && !isMenuOpen ? 'bg-transparent' : 'bg-black/95 backdrop-blur-md'}`}>
            <div className="mx-auto max-w-screen-xl h-full py-4 xl:py-0 px-4">
                <div
                    className={`uppercase flex justify-between items-center h-full text-white ${isMenuOpen ? 'flex-col' : 'flex-row'}`}>
                    <div className="h-full w-2/5 xl:w-auto py-0 xl:py-4">
                        <a href="/" className={` ${isMenuOpen ? 'mb-2 flex justify-center items-center' : ''}`}>
                            <GymLogo
                                className="max-h-12 xl:max-h-full h-full transition-colors hover:fill-primary-300"/>
                        </a>
                    </div>
                    <button
                        className={`xl:hidden mx-4 text-white ${isMenuOpen ? 'absolute top-5 right-4' : ''}`}
                        onClick={toggleMenu}
                    >
                        {menuIcon}
                    </button>
                    <div
                        className={`header-menu py-4 font-semibold xl:py-0 flex ${isMenuOpen ? 'flex-col items-center space-y-4' : 'hidden xl:flex'} xl:space-x-10 xl:space-y-0`}>

                        {/* About dropdown */}
                        <div
                            className="relative"
                            onMouseEnter={() => !isMenuOpen && setIsAboutOpen(true)}
                            onMouseLeave={() => !isMenuOpen && setIsAboutOpen(false)}
                        >
                            <button
                                onClick={() => setIsAboutOpen(!isAboutOpen)}
                                className={`header-menu-item uppercase flex items-center gap-1.5 ${aboutPaths.includes(location.pathname) ? 'active-link' : ''}`}
                            >
                                Over
                                <FontAwesomeIcon
                                    icon={faChevronDown}
                                    className={`text-xs transition-transform duration-200 ${isAboutOpen ? 'rotate-180' : ''}`}
                                />
                            </button>

                            {/* Desktop dropdown */}
                            {isAboutOpen && !isMenuOpen && (
                                <div className="absolute top-full left-0 flex flex-col bg-black/95 backdrop-blur-md rounded-b shadow-xl overflow-hidden z-10 whitespace-nowrap">
                                    <Link to="/concept" onClick={closeMenu}
                                          className={`block w-full px-5 py-3 text-sm hover:text-primary-400 hover:bg-white/5 transition-colors ${location.pathname === '/concept' ? 'text-primary-400' : ''}`}>
                                        Het Concept
                                    </Link>
                                    <Link to="/about" onClick={closeMenu}
                                          className={`block w-full px-5 py-3 text-sm hover:text-primary-400 hover:bg-white/5 transition-colors ${location.pathname === '/about' ? 'text-primary-400' : ''}`}>
                                        Over Nick
                                    </Link>
                                    <Link to="/rooms" onClick={closeMenu}
                                          className={`block w-full px-5 py-3 text-sm hover:text-primary-400 hover:bg-white/5 transition-colors ${location.pathname === '/rooms' ? 'text-primary-400' : ''}`}>
                                        De gym
                                    </Link>
                                    <Link to="/faq" onClick={closeMenu}
                                          className={`block w-full px-5 py-3 text-sm hover:text-primary-400 hover:bg-white/5 transition-colors ${location.pathname === '/faq' ? 'text-primary-400' : ''}`}>
                                        FAQ
                                    </Link>
                                </div>
                            )}

                            {/* Mobile inline */}
                            {isAboutOpen && isMenuOpen && (
                                <div className="flex flex-col items-center space-y-3 pt-2">
                                    <Link to="/concept" onClick={closeMenu}
                                          className={`text-sm header-menu-item ${location.pathname === '/concept' ? 'active-link' : ''}`}>
                                        Het Concept
                                    </Link>
                                    <Link to="/about" onClick={closeMenu}
                                          className={`text-sm header-menu-item ${location.pathname === '/about' ? 'active-link' : ''}`}>
                                        Over Nick
                                    </Link>
                                    <Link to="/rooms" onClick={closeMenu}
                                          className={`text-sm header-menu-item ${location.pathname === '/rooms' ? 'active-link' : ''}`}>
                                        De gym
                                    </Link>
                                    <Link to="/faq" onClick={closeMenu}
                                          className={`text-sm header-menu-item ${location.pathname === '/faq' ? 'active-link' : ''}`}>
                                        FAQ
                                    </Link>
                                </div>
                            )}
                        </div>

                        <Link to="/membership" onClick={closeMenu}
                              className={`header-menu-item ${location.pathname === '/membership' ? 'active-link' : ''}`}>Lidmaatschap</Link>
                        <Link to="/pictures" onClick={closeMenu}
                              className={`header-menu-item ${location.pathname === '/pictures' ? 'active-link' : ''}`}>Impressies</Link>
                    </div>
                    <div
                        className={`flex font-semibold ${isMenuOpen ? 'flex-col items-center space-y-4' : 'hidden xl:flex'} xl:space-x-4 xl:space-y-0 justify-center items-center`}>
                        <Link className={`secondary-button ${location.pathname === '/contact' ? 'active-link' : ''}`}
                              to="/contact"
                              onClick={closeMenu}>
                            Contact opnemen
                        </Link>
                        <button className="primary-button" onClick={() => {
                            goToMemberships(navigate);
                            closeMenu();
                        }}>Direct inschrijven
                        </button>
                    </div>
                </div>
            </div>
            {!isTop && <ProgressBar/>}
        </nav>
    );
};

export default HeaderBar;
